// src/screens/LoginScreen.js
import React, { useState } from "react";
import { signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { auth, db } from "../firebase";
import { doc, setDoc } from "firebase/firestore";

function LoginScreen() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  // ✅ Email/Password Login
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);

      const user = userCredential.user;
      await setDoc(
        doc(db, "users", user.uid),
        {
          uid: user.uid,
          email: user.email,
        },
        { merge: true }
      );
    } catch (err) {
      setError("Invalid email or password. Please try again.");
    }
  };

  // ✅ Google Login
  const handleGoogleLogin = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);

      const user = result.user;
      await setDoc(
        doc(db, "users", user.uid),
        {
          uid: user.uid,
          email: user.email,
          displayName: user.displayName,
          photoURL: user.photoURL,
          provider: "google",
        },
        { merge: true }
      );
    } catch (err) {
      setError("Google sign-in failed. Please try again.");
    }
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gradient-to-br from-blue-200 via-blue-50 to-blue-100 dark:from-gray-950 dark:via-gray-900 dark:to-gray-950">
      <div className="relative bg-white/80 dark:bg-gray-900/80 shadow-2xl backdrop-blur-md rounded-3xl p-8 w-96 border border-gray-200/50 dark:border-gray-700/50">
        
        <h2 className="text-3xl font-extrabold mb-6 text-center text-gray-900 dark:text-gray-100 tracking-wide">
          MUN Sarthi
        </h2>

        {error && (
          <div className="bg-red-100 dark:bg-red-900/70 text-red-700 dark:text-red-300 p-3 rounded-lg mb-5 text-sm shadow-sm border border-red-200 dark:border-red-800">
            {error}
          </div>
        )}

        {/* 🔹 Email Login Form */}
        <form onSubmit={handleLogin} className="space-y-5">
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300">
              Email
            </label>
            <input
              type="email"
              placeholder="Enter your email"
              className="w-full px-4 py-2.5 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-500 outline-none transition dark:bg-gray-800 dark:text-gray-100 dark:border-gray-700"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300">
              Password
            </label>
            <input
              type="password"
              placeholder="Enter your password"
              className="w-full px-4 py-2.5 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-500 outline-none transition dark:bg-gray-800 dark:text-gray-100 dark:border-gray-700"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-2.5 rounded-xl font-medium shadow-lg hover:scale-[1.02] transition-transform duration-200 hover:shadow-xl dark:from-blue-700 dark:to-indigo-700"
          >
            Login with Email
          </button>
        </form>

        {/* 🔹 Separator */}
        <div className="flex items-center my-6">
          <div className="flex-grow h-px bg-gray-300 dark:bg-gray-700"></div>
          <span className="px-3 text-gray-500 text-sm dark:text-gray-400">OR</span>
          <div className="flex-grow h-px bg-gray-300 dark:bg-gray-700"></div>
        </div>

        {/* 🔹 Google Login Button */}
        <button
          onClick={handleGoogleLogin}
          className="w-full flex items-center justify-center gap-3 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 py-2.5 rounded-xl shadow-md hover:bg-gray-50 dark:hover:bg-gray-700 transition"
        >
          <img
            src="https://developers.google.com/identity/images/g-logo.png"
            alt="Google"
            className="w-5 h-5"
          />
          <span className="text-gray-700 dark:text-gray-200 font-medium">
            Continue with Google
          </span>
        </button>
      </div>
    </div>
  );
}

export default LoginScreen;